<template>
  <div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name"
        width="200px">
      </el-table-column>
      <el-table-column
        prop="contractName"
        label="Contract"
        width="200px">
      </el-table-column>
      <el-table-column
        prop="programs"
        label="Programs"
        >
        <template slot-scope="scope">
          <el-tag :key="tag.id" v-for="tag in scope.row.programs" style="marginRight: 10px">
            {{tag.name}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="month"
        label="Month"
        width="85px">
        <template slot-scope="scope">
          {{scope.row.month.format('MMM YY')}}
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="Status"
        width="90px">
        <template slot-scope="scope">
          <icon v-if="scope.row.status === 'pending'" name='regular/clock'  class="pending icon"></icon>
          <icon v-if="scope.row.status === 'complete'" name='regular/check-circle'  class="complete icon"></icon>
        </template>
      </el-table-column>
      <el-table-column
        prop="manager"
        label="Manager"
        width="150px">
      </el-table-column>
      <el-table-column
        width="60"
        prop="view"
        label="view"
        >
        <template slot-scope="scope">
          <div @click="viewReport(scope.row)">
            <icon name='search-plus'  class="el-icon-menu icon"></icon>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      id="userDialog"
      :visible.sync="dialogVisible"
      width="60%"
      v-bind:append-to-body='true'
      >
      <h2 slot="title" style="margin: 0px">
        {{activeReport.name}} : {{activeReport.month}}
      </h2>
      <ReportView :reportData="activeReport" @updateReports="updateReports"/>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment'
  import ReportView from './ReportView'
  export default {
    props: ['tableData', 'updateReports2'],
    components: {
      ReportView
    },
    data () {
      return {
        moment,
        activeReport: {},
        dialogVisible: false
      }
    },
    methods: {
      viewReport (data) {
        this.activeReport = data
        this.dialogVisible = true
      },
      updateReports () {
        this.dialogVisible = false
        this.$emit('updateReports2')
      }
    }
  }
</script>

<style scoped>
  .icon {
    margin-left: 10px;
    margin-top: 10px;
  }
  .pending{
    color: orange;
  }
  .complete {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReportTable.vue